import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Radio, Form, Input, Button, Modal} from 'antd';
import { map } from 'lodash';

import moment from 'moment';
import { SURVEY_CONSTANTS, VALIDATION } from '../../constants/commonConstants';
import './survey-modal.less';
import { GLOBAL_URL } from '../../constants/dataServiceUrl';
import {
  getSurveyQuestions,
  saveSurvey,
} from '../../../store/actions/authAction';
import { RootState } from '../../../store';
import { ApplicationDetailModel } from '../../../store/models/applicationDetailModel';
import { getNoOfHours } from '../../../modules/crm/inPatient/service/crmUtils';
import Link from 'antd/lib/typography/Link';
import FormInputNumber from '../crmFormElement/FormInputNumber/FormInputNumber';
import { FormTextInput } from '../crmFormElement/FormInput';

const SurveyModal = (): ReactElement => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isModal, setIsModal] = useState(false);
  const [selectedRadio, setSelectedRadio] = useState({});
  const [comments, setComments] = useState([]);
  const [, setDelay] = useState(false);
  const [loader, setLoader] = useState(false);
  const [surveyQuestions, setSurveyQuestions] = useState([]);
  const surveyQuestionsStore = useSelector((state: RootState): any => state?.auth?.surveyQuestions);
  const userSurveyDetailsStore = useSelector((state: RootState): any => state?.auth?.userSurveyDetails);
  const surveyRespStore = useSelector((state: RootState): any => state?.auth?.surveyResp);
  const appDetail: any = useSelector((state: RootState): ApplicationDetailModel => state.applicationDetail);
  const providerId: string = appDetail?.getProviderId();
  const providerName: string = appDetail?.getProviderName();
  const currentDate = moment(new Date());
  const emailId: string = appDetail?.getUserEmail();

  useEffect((): void => {
    if (providerId) {
      dispatch(getSurveyQuestions(providerId));
    }
  }, [providerId]);

  useEffect((): void => {
    const { surveyDone, doLater} = userSurveyDetailsStore;
    setSurveyQuestions(surveyQuestionsStore);
    if (!surveyDone && (process.env.REACT_APP_IS_MULTIPAYER_FOR_SURVEY === 'true')) {
      if (getNoOfHours(currentDate, moment(userSurveyDetailsStore?.doLater)) < 0) {
        setSurveyQuestions(surveyQuestionsStore);
        setIsModal(true);
      } else if (doLater === null) {
        setSurveyQuestions(surveyQuestionsStore);
        setIsModal(true);
      } else {
        setIsModal(false);
      }
    } if (!surveyDone) {
      if (getNoOfHours(currentDate, moment(userSurveyDetailsStore?.doLater)) < 0) {
        setIsModal(true);
      } else if (doLater === null) {
        setIsModal(true);
      } else {
        setIsModal(false);
      }
    }
  }, [userSurveyDetailsStore, surveyQuestionsStore]);

  useEffect((): void => {
    if (surveyRespStore?.isSuccess) {
      setTimeout((): void => {
        setIsModal(false);
      }, 3000);
    }
  }, [surveyRespStore]);

  const onChangeHandler = (
    event: any,
    questionId: string,
    inputType: string,
  ): any => {
    const { value } = event.target;

    if (inputType === 'radio') {
      setSelectedRadio({
        ...selectedRadio,
        [questionId]: value,
      });
    } else {
      setComments({
        ...comments,
        [questionId]: value,
      });
    }

    if (value === '0') {
      setDelay(true);
      setTimeout((): void => {
        setIsModal(false);
      }, 3000);
    }

    form.setFields([
      {
        name: questionId,
        value,
        errors: [],
      },
    ]);
  };

  const onSubmit = (values: any): any => {
    let surveyResopnse: any = [];
    map(values, (ans: string, questionId: number): void => {
      surveyResopnse = [
        ...surveyResopnse,
        {
          questions: questionId,
          answer: comments[questionId] || '',
          comment: selectedRadio[questionId] || '',
        },
      ];
    });
    const data =  {
      providerId,
      surveyResopnse,
      doLater: false,
      emailId,  // adding emailId in payload for saving survey data (IPP-3936)
    };

    setLoader(true);
    dispatch(saveSurvey(data));
  };

  const handleClose = (): void => {
    const data =  {
      providerId,
      surveyResopnse: [],
      doLater: true,
    };
    dispatch(saveSurvey(data));
    setIsModal(false);
  };
  return (
    <Modal
      title={
        <div>
          <img
            src={`${GLOBAL_URL.REACT_APP_COMMON_BUCKET_URL}ihx-logo.png`}
            width="75"
            alt="Logo"
          />
          {process.env.REACT_APP_IS_MULTIPAYER_FOR_SURVEY === 'true' ?
            <div className="text-center text">{SURVEY_CONSTANTS.FEEDBACK_TEXT}</div>
            :
            <div className="text-center text">{SURVEY_CONSTANTS.HOSPITAL_SURVEY}</div>
          }
        </div>
      }
      visible={appDetail.getIsSurveyEnabled() && isModal}
      onCancel={handleClose}
      footer={false}
      width="max-content"
      className="survey-model"
      maskClosable={false}
      closable={false}
      keyboard={false}
    >
      {
        surveyRespStore?.isSuccess && process.env.REACT_APP_IS_MULTIPAYER_FOR_SURVEY === 'true' ? (
          <div>
            <h4 className="text-center text">{SURVEY_CONSTANTS.SUCCESS_TEXT}</h4>
            <h4 className="text-center text">
              {SURVEY_CONSTANTS.SURVEY_SUCCESS_MESSAGE.split(SURVEY_CONSTANTS.RESOURCE_LINK_TEXT)[0]}
              <Link href={SURVEY_CONSTANTS.RESOURCE_LINK_HREF}>
                {SURVEY_CONSTANTS.RESOURCE_LINK_TEXT}
              </Link>
              {SURVEY_CONSTANTS.SURVEY_SUCCESS_MESSAGE.split(SURVEY_CONSTANTS.RESOURCE_LINK_TEXT)[1]}
            </h4>
          </div>
        ) : process.env.REACT_APP_IS_MULTIPAYER_FOR_SURVEY === 'false' && surveyRespStore?.isSuccess ? (
          <h4 className="text-center text">{SURVEY_CONSTANTS.SUCCESS_TEXT}</h4>
        ) : process.env.REACT_APP_IS_MULTIPAYER_FOR_SURVEY === 'true' ?
          (
            <Form
              form={form}
              onFinish={onSubmit}
            >
              {surveyQuestions &&
                surveyQuestions.length >= 0 &&
                map(surveyQuestions, (sq: any, sqIndex: number): ReactElement => (
                  <React.Fragment key={sqIndex}>
                    <div
                      className="question-label"
                      dangerouslySetInnerHTML={{
                        __html: `<p class="${sq.isRequired ? 'required' : ''
                          }">${sq.question} </p>`,
                      }}
                    />
                    <Form.Item
                      name={sq.questionId}
                      rules={
                        [{ required: true, message: 'Select a valid option' }]
                      }
                      className={sq.questionId === '3' ? 'inline-input' : ''}
                    >
                      <Radio.Group
                        onChange={(event: any): void =>
                          onChangeHandler(event, sq?.questionId, 'radio')
                        }
                        value={selectedRadio[sq.questionId]}
                      >
                        {sq &&
                          sq.options &&
                          sq.options.length > 1 &&
                          map(sq.options, (sqo: any, sqoIndex: number): ReactElement => (
                            <Radio
                              key={sqoIndex}
                              value={sqo.value}
                              name={sq.questionId}
                              data-testid="username"
                            >
                              {sqo.label}
                            </Radio>
                          ))}
                      </Radio.Group>

                      {sq.shouldHasTextBox &&
                        sq.shouldHasTextBox.length > 0 &&
                        sq.shouldHasTextBox.includes(
                          selectedRadio[sq.questionId],
                        ) && (
                          <>{sq.textBoxLabel ?
                            sq.questionId === '3' ? (
                              <Input />
                            ) : <FormTextInput detail={{
                              label: sq.textBoxLabel,
                              require: false,
                              size: 12,
                              onChange: (event: any): any => onChangeHandler(event, sq?.questionId, 'input'),
                            }} /> : (
                              <Form.Item
                                label={sq.textBoxLabel}
                                className="ant-col-24"
                              >
                                <FormInputNumber detail={{
                                  label: 'Contact No',
                                  require: false,
                                  size: 12,
                                  onChange: (event: any): any => onChangeHandler(event, sq?.questionId, 'input'),
                                }} />
                              </Form.Item>
                            )
                          }
                          </>
                        )}
                    </Form.Item>
                  </ React.Fragment>
                ))}

              <div className="text-right mt-md">
                <Button
                  data-testid="survey-cancel"
                  className="m-r-15"
                  type="default"
                  onClick={handleClose}
                >
                  {SURVEY_CONSTANTS.REMIND_LATER}
                </Button>

                <Button
                  data-testid="survey-submit"
                  type="primary"
                  htmlType="submit"
                  loading={loader}
                >
                  {SURVEY_CONSTANTS.SUBMIT}
                </Button>
              </div>
            </Form>
          ) :
          <Form
            form={form}
            onFinish={onSubmit}
            validateMessages={VALIDATION}
            requiredMark="optional"
          >
            {surveyQuestions &&
              surveyQuestions.length >= 0 &&
              map(surveyQuestions, (sq: any, sqIndex: number): ReactElement => (
                <React.Fragment key={sqIndex}>
                  <div
                    className="question-label"
                    dangerouslySetInnerHTML={{
                      __html: `<p class="${sq.isRequired ? 'required' : ''
                        }">${sq.question.replace('<HOSPITAL_NAME>', providerName)} </p>`,
                    }}
                  />
                  {sq.shouldHasTextBox &&
                    sq.shouldHasTextBox.length > 0 &&
                    (
                      <>
                        {sq.questionId === '12' ? (
                          <Form.Item
                            label={sq.textBoxLabel}
                            className="ant-col-24"
                            name={'Software Survey'}
                            rules={[{ required: true }]}
                          >
                            <Input />
                          </Form.Item>
                        ) : (
                          <Form.Item
                            label={sq.textBoxLabel}
                            className="ant-col-24"
                          />
                        )}
                      </>
                    )}
                </ React.Fragment>
              ))}
            <div className="text-right mt-md">
              <Button
                data-testid="survey-cancel"
                className="m-r-15"
                type="default"
                onClick={handleClose}
              >
                {SURVEY_CONSTANTS.REMIND_LATER}
              </Button>

              <Button
                data-testid="survey-submit"
                type="primary"
                htmlType="submit"
                loading={loader}
              >
                {SURVEY_CONSTANTS.SUBMIT}
              </Button>
            </div>
          </Form>
      }
    </Modal>
  );
};

export default SurveyModal;
